document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.head-home');
    sections.forEach(section => {
        const iframe = section.querySelector('.head-home__video-iframe');
        if (iframe) {
            // Aggiungiamo i parametri necessari per YouTube
            const src = iframe.src;
            if (!src.includes('autoplay=1')) {
                iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1';
            }
        }
    });
});